import React, { useState } from 'react';
import { Button, Input, Popconfirm, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useDirectOrder } from '../../../context/DirectOrderContext';

const DeletePanel = () => {
  const { isAdmin, isApprover, deleteDirectOrder } = useDirectOrder();
  const [orderId, setOrderId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!orderId || !orderId.trim()) {
      message.error('Please enter a Direct Order ID');
      return;
    }

    if (!isAdmin && !isApprover) {
      message.error('Only administrators and approvers can delete Direct Orders');
      return;
    }

    setLoading(true);
    try {
      const result = await deleteDirectOrder(orderId.trim());
      if (result) {
        setOrderId('');
      }
    } catch (error) {
      // the context reports the failure
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="do-panel do-danger">
      <div className="do-panel__head">
        <div>
          <h2 className="do-panel__title" style={{ color: 'var(--do-bad)' }}>Delete by ID</h2>
          <p className="do-panel__hint">Permanently removes the order. This cannot be undone.</p>
        </div>
      </div>
      <div className="do-panel__body">
        <div style={{ display: 'flex', gap: 8, maxWidth: 460 }}>
          <Input
            placeholder="Direct order ID, e.g. 123"
            aria-label="Direct order ID"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
          />
          <Popconfirm
            title={`Delete direct order ${orderId}?`}
            description="This cannot be undone."
            onConfirm={handleDelete}
            okText="Delete"
            cancelText="Keep"
            okButtonProps={{ danger: true }}
          >
            <Button danger type="primary" icon={<DeleteOutlined />} loading={loading} disabled={!orderId || !orderId.trim()}>
              Delete
            </Button>
          </Popconfirm>
        </div>
      </div>
    </section>
  );
};

export default DeletePanel;
